import { createSlice } from '@reduxjs/toolkit';

import { loadExcessiveAlarms } from '@sophocles/features/alarms/api';

const slice = createSlice({
  name: 'alarms',
  initialState: {
    sites: {},
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(loadExcessiveAlarms.fulfilled, (state, action) => {
        state.sites[action.meta.arg] = action.payload.alarms;
      })
      .addCase(loadExcessiveAlarms.rejected, (state, action) => {});
  },
});

export const selectAlarms = state => {
  return state.alarms;
};

const { reducer } = slice;
export default reducer;
